<template>
    <table :key="key" class="table table-sm border-0">
        <tr>
            <td style="width: 20%">
                <search-client
                    size="sm"
                    :show-label="true"
                    show-feedback="false"
                    @client-is-set="setClientId"
                />
            </td>
            <td style="width: 20%">
                <label>Affectation</label>
                <b-form-select
                    v-model="selectedValue"
                    size="sm"
                    :options="affectationOptions"
                />
            </td>

            <td style="width: 8%">
                <label>Exercice</label>
                <b-form-select
                    v-model="form.fiscal_year"
                    size="sm"
                    :options="fiscalYearOptions"
                />
            </td>
            <td style="width: 8%">
                <label>Durée</label>
                <b-form-input
                    v-model="form.activity_duration"
                    size="sm"
                    placeholder="0.00"
                    class="text-center"
                    :formatter="decimalString"
                    :state="!disabled"
                >
                </b-form-input>
            </td>
            <td>
                <label>Commentaires</label>
                <b-form-input
                    v-model="form.comments"
                    size="sm"
                    placeholder="Saisissez vos commentaires"
                >
                </b-form-input>
            </td>
            <td class="text-right" style="padding-top: 37px; width: 4%">
                <b-link
                    title="Enregistrer"
                    class="text-success"
                    :disabled="disabled"
                    @click="saveTime"
                >
                    <i class="fas fa-save fa-fw fa-lg"></i>
                </b-link>
            </td>
        </tr>
    </table>
</template>

<script>
import { mapState } from 'vuex'
import SearchClient from '../../clients/components/SearchClient'
import Formatter from '../../../common/mixins/Formatter'

export default {
    name: 'EntryCreate',

    components: { SearchClient },

    mixins: [Formatter],

    data() {
        return {
            form: {
                type: null,
                client_id: null,
                activity_duration: null,
            },
            clientIsSet: false,
            fiscalYearOptions: [],
            affectationOptions: [
                { value: null, text: 'Commencer par définir le client' },
            ],
            key: Date.now(),
            selectedValue: null,
        }
    },

    async created() {
        await this.getAffectationOptions()
        this.initFiscalYear()
    },

    methods: {
        initFiscalYear() {
            const actualYear = new Date().getFullYear()
            const previousYear = actualYear - 1
            const nextYear = actualYear + 1
            this.form.fiscal_year = actualYear
            this.fiscalYearOptions.push({
                value: actualYear,
                text: actualYear.toString(),
            })
            this.fiscalYearOptions.push({
                value: previousYear,
                text: previousYear.toString(),
            })
            this.fiscalYearOptions.push({
                value: nextYear,
                text: nextYear.toString(),
            })
        },

        setClientId(client) {
            this.form.client_id = client.id
            this.clientIsSet = true
            this.getAffectationOptions()
        },

        async saveTime() {
            this.form.activity_date = this.activityDate
            this.form.type = this.selectedValue.type
            this.form.id = this.selectedValue.id
            this.$store.commit('timeSheetsVM/RESET_ERROR')
            try {
                await axios.post('/time-sheets', this.form)
                this.$emit('entry-created')
                this.reset()
            } catch (error) {
                console.log(error)
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.meta.message
                        )
                    }
                }
            }
        },

        async getAffectationOptions() {
            const url = this.clientIsSet
                ? `/time-sheet-options/billable/${this.form.client_id}`
                : '/time-sheet-options/non-billable-selectable'
            try {
                const response = await axios.get(url)
                this.affectationOptions = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        reset() {
            this.$root.$refs.timeSheetsInput.getData()
            this.key = Date.now()
            this.affectationOptions = [
                {
                    value: null,
                    text: 'Commencer par définir le client',
                },
            ]
        },
    },

    computed: {
        ...mapState({
            activityDate: (state) => state.timeSheetsVM.currentDate,
        }),

        disabled() {
            return (
                this.form.activity_duration === null ||
                this.form.activity_duration === 0 ||
                this.form.activity_duration === '0' ||
                this.form.activity_duration === ''
            )
        },
    },
}
</script>

<style scoped></style>
